<template>
  <a class="jump" v-scroll-to="{ el: '#top', offset: -100 }" id="scroll-top">
    <font-awesome-icon icon="chevron-up" />
  </a>
</template>

<script>
export default {
  name: "ScrollTop"
}
</script>

<style>
#scroll-top {
  position: fixed;
  right: 52px;
  bottom: 10px;
  z-index: 1000;
  background: #fff;
  font-size: 40px;
  width: 60px;
  height: 60px;
  border: 1px solid #ccc;
  text-align: center;
  box-shadow: rgba(0,0,0,.1) 0 0 27px;
  transition: all .3s;
  opacity: .5;
  cursor: pointer;
}
#scroll-top:hover {
  opacity: 1;
  color: #CF5651;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/ScrollTop.vue